import { connect } from "react-redux";
import { RootReducerProps } from "../reducers/index";

const mapStateToProps = (state: RootReducerProps, ownProps: any) => ({
  ...ownProps,
  eventId: state.reportLock.eventId,
  lockEvent: state.reportLock.lockEvent,
  lockEventReportId: state.reportLock.lockEventReportId,
  lockEventLockedBy: state.reportLock.lockEventLockedBy,
  lockEventForceReleased: state.reportLock.lockEventForceReleased,
  lockEventDraftUpdate: state.reportLock.lockEventDraftUpdate,
  assignmentChangedEventId: state.reportLock.assignmentChangedEventId,
  assignmentChangedCaseId: state.reportLock.assignmentChangedCaseId,
  assignmentChangedIsRemoved: state.reportLock.assignmentChangedIsRemoved,
});

const ReportLockContainer = (component: any) => {
  return connect(mapStateToProps)(component);
};

export default ReportLockContainer;
